module.exports = __webpack_public_path__ + "img/process-notary.df3e7680.png";